<template>
  <div class="accueil">
    <div class="container">
      <div class="header">
        <h1>Adhésion en ligne ARAPL</h1>
        <p>Bienvenue sur notre plateforme d'adhésion en ligne pour les entrepreneurs</p>
      </div>
      
      <div class="content">
        <p>
          Cette plateforme vous permet de déterminer votre catégorie de revenu fiscal et de choisir le pack d'adhésion adapté à votre situation.
        </p>
        <p>
          Nous allons vous poser quelques questions pour vous guider dans ce processus.
        </p>
        
        <div class="action-buttons">
          <button class="btn btn-primary" @click="commencerQuestionnaire">Commencer le questionnaire</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AccueilView',
  data() {
    return {
      submitAttempted: false,
    };
  },
  methods: {
    commencerQuestionnaire() {
      this.$router.push('/questionnaire');
    }
  }
}
</script>

<style scoped>
.accueil {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.header {
  text-align: center;
  margin-bottom: 30px;
}

.header h1 {
  color: #2c3e50;
  margin-bottom: 10px;
}

.content {
  margin-bottom: 30px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary {
  background-color: #4CAF50;
  color: white;
}

.btn-primary:hover {
  background-color: #45a049;
}
</style>
